import React from "react";
import { buildRoutes } from "@app/routes/RouteBuilder";
import lazyWithRetry from "@shared/utils/lazyWithRetry";

// Lazy loading con retry automático
const MenuFormatos = lazyWithRetry(
  () => import("./ui/MenuFormatos"),
  "MenuFormatos",
);
const CrearFormato = lazyWithRetry(
  () => import("./ui/CrearFormato"),
  "CrearFormato",
);
const ActualizarFormato = lazyWithRetry(
  () => import("./ui/ActualizarFormato"),
  "ActualizarFormato",
);
const GestionPersonalizaciones = lazyWithRetry(
  () => import("./ui/GestionPersonalizaciones"),
  "GestionPersonalizaciones",
);

/**
 * Rutas de gestión de formatos
 */
const formatsRoutes = buildRoutes([
  {
    path: "/formatos",
    element: MenuFormatos,
    roles: [1, 2, 3, 5, 7],
  },
  {
    path: "/formatos/crear",
    element: CrearFormato,
    roles: [1, 2, 3, 5, 7],
  },
  {
    path: "/formatos/actualizar",
    element: ActualizarFormato,
    roles: [1, 2, 3, 5, 7],
  },
  {
    path: "/formatos/personalizaciones",
    element: GestionPersonalizaciones,
    roles: [1, 2, 3, 5, 7],
  },
]);

export default formatsRoutes;
